<template>
    <section class="products-section section section--white" style="padding: 60px 0 0 0;">
      <div class="container">
        <div class="products-layout flex">
          <!-- 左侧分类导航 -->
          <div class="category-sidebar">
            <div class="category-group" v-for="category in categories" :key="category.id">
              <h3 class="category-title section-title section-title--small">{{ category.name }}</h3>
              <ul class="category-list" v-if="category.children && category.children.length">
                <li
                    v-for="item in category.children"
                    :key="item.id"
                    :class="{'active': menuId === item.id}"
                    @click="handleCategoryClick(item)">
                  <span>{{ item.name }}</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- 右侧产品列表 -->
          <div class="products-container" v-loading="loading" element-loading-text="加载中...">
            <div class="products-grid">
              <div v-for="product in filteredProducts"
                   :key="product.id"
                   class="product-card card hover-lift"
                   @click="handleProductClick(product)">
                <div class="product-image">
                  <img v-lazy="product.cover+ '?x-oss-process=image/resize,w_196'" :alt="product.name" class="img-cover">
                </div>
                <div class="product-content">
                  <h3 class="product-name">{{ product.name }}</h3>
                  <p class="product-chemical-name text-content text-content--small" style="margin: 0 0 28px; color: #293340;">{{ product.nameOther || '--' }}</p>
                  <div class="product-info text-content text-content--small" style="color: #293340;">
                    <span class="product-cas">{{ $t('products.panel.CAS') }}: {{ product.casNo }}</span>
                    <span class="product-sn">{{ $t('products.panel.ArtNo') }}: {{ product.sn }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 无数据提示 -->
            <div v-if="!loading && filteredProducts.length === 0" class="no-data">
              暂无相关产品
            </div>

          </div>
        </div>

      </div>
      <!-- 分页器 -->
      <div v-if="filteredProducts.length > 0" class="pagination-section" style="background-color: rgba(185, 194, 205, .2); padding: 42px;">
        <div class="pagination-wrapper container" style="width: 1520px; padding-left: 420px;">
          <Pagination
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handlePageChange"
          />
        </div>
      </div>
    </section>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getProductCenterList } from '@/api/products'
import {mapState} from "vuex";
import Pagination from '@/components/Pagination.vue'
import {pushWithLanguage} from "@/utils/routeUtils";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductsList',
  components: {
    Pagination
  },

  data() {
    return {
      bannerBg: 'https://file.yacoo.com.cn/staticResource/products/products-header-bg.webp?x-oss-process=image/resize,h_480',
      searchKeyword: '',
      filteredProducts: [],
      categories: [], // 所有分类数据
      menuId: '',
      categoryInfo: null,
      pageSize: 10,
      loading: false,
      productQuery: {
        productId: '',
        name: '',
        parentId: '',
        parentName: ''
      }
    }
  },

  props: {
    products: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    selectedCategory: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },

  watch: {
    selectedCategory: {
      handler(newVal, oldVal) {
        // 监听分类变化
        this.menuId = newVal
      },
      immediate: true
    },
    products: {
      handler(newVal, oldVal) {
        this.filteredProducts = newVal
        this.initAnimations()
      },
      immediate: true
    },
    currentLanguage: {
      handler() {
        this.getCategories()
      }
    }
  },

  created() {
    this.getCategories ()
  },

  mounted() {

  },

  methods: {
    async getCategories() {
      try {
        const response = await getProductCenterList()
        if (response.success) {
          this.categories = response.data
        } else {
          this.$message.error(response.msg || '获取产品分类失败')
        }
      } catch (error) {
        console.error('获取产品分类失败:', error)
        this.$message.error('获取产品分类失败，请稍后重试')
      }
    },

    handleCategoryClick(item) {
      if (item.category === 1) {
        pushWithLanguage('/products/list/'+ item.code , this.currentLanguage).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
        return
      }
      this.menuId = item.id
      //传递给父组件
      this.$emit('getSelectedCategory', this.menuId)
      pushWithLanguage('/products/list/'+ item.code , this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    handleProductClick(product) {
      // 传递当前分类信息到详情页
      pushWithLanguage( `/products/${product.id}` , this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    handlePageChange(page) {
      //传递给父组件
      this.$emit('pageChange', page)
    },

    initAnimations() {

      // 产品卡片动画
      this.$nextTick(() => {
        // 使用 timeline 控制动画序列
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: '.products-grid',
            start: 'top 80%',
            end: 'bottom 50%',
            toggleActions: 'play none none none',
            once: true // 只执行一次
          }
        })

        // 添加产品卡片入场动画
        tl.from('.product-card', {
          y: 30,
          opacity: 0,
          duration: 0.3,
          stagger: {
            amount: 0.5,
            ease: 'power2.out'
          },
          clearProps: 'all' // 动画完成后清除属性
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/styles/variables.less';
@import '@/assets/styles/mixins.less';

  .products-section {
    // 使用公共 section section--white container flex 等样式
    .products-layout {
      display: flex;
      gap: 50px;
    }

    .category-sidebar {
      width: 340px;
      flex-shrink: 0;
      padding-right: 49px;
      height: fit-content;
      border-right: 1px solid #D8D8D8;

      .category-group {
        margin-bottom: 30px;
      }

      .category-title {
        // 用公共 section-title section-title--small
        font-size: 32px;
        font-weight: 600;
        color: #333;
        margin: 0 0 40px;
        padding-bottom: 0;
        border-bottom: none;
      }

      .category-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          padding: 12px 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
          transition: all 0.3s;
          color: #666;
          background-color: #fff;
          margin-bottom: 2px;
          font-size: 20px;

          &:hover {
            color: #333;
          }

          &.active {
            background-color: #f5f5f5;
            color: #333;

          }
        }
      }
    }

    .products-container {
      flex: 1;
    }

    .products-grid {
      display: flex;
      flex-direction: column;
      gap: 22px;
      margin-bottom: 40px;
    }

    .product-card {
      width: 100%;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;
      cursor: pointer;
      display: flex;
      border: 1px solid #eee;
      padding: 14px 26px;

      &:hover {
        transform: translateY(-5px);
      }

      .product-image {
        flex-shrink: 0;
        overflow: hidden;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 196px;
          height: auto;
          object-fit: cover;
        }
      }

      .product-content {
        padding: 18px 29px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .product-name {
        font-size: 32px;
        font-weight: normal;
        color: #293340;
        margin: 0 0 19px;
      }

      .product-chemical-name {
        // 用公共 text-content text-content--small
        font-size: 20px;
        color: #293340;
        margin: 0 0 28px;
      }

      .product-info {
        display: flex;
        gap: 20px;
        font-size: 20px;
        color: #293340;

        .product-cas, .product-sn {
          display: inline-block;
        }
      }
    }

    .pagination-section {
      background-color: rgba(185, 194, 205, .2);
      padding: 42px;
    }

    .pagination-wrapper {
      &.container {
        width: 1520px;
        padding-left: 420px;
      }
    }

    .no-data {
      text-align: center;
      padding: 40px 0;
      color: #999;
      font-size: 14px;
    }
  }
</style>